import React, { Component } from "react";

import workouts from "./workouts.json";

import "./WorkoutBuilder.css";

class WorkoutBuilder extends Component {
  state = {
    PR: { minutes: 5, seconds: 0 },
    schedule: [[]],
    today: null,
    raceday: new Date(Date.parse("25 Dec 2020")),
    pace: 75,
    mileage: 40,
  };

  inputChangeHandler = (event, inputId) => {
    console.log("changing");
    const PR = { ...this.state.PR };
    PR[inputId] = +event.target.value;
    const pace = (PR["minutes"] * 60 + PR["seconds"]) / 4;
    console.log(pace);
    this.setState({ PR: PR, pace: pace });
  };

  rounder = (num, unit) => {
    console.log(num, unit);
    console.log(Math.round(num / unit) * unit);
    return Math.round(num / unit) * unit;
  };
  pad = (n) => {
    return n < 10 ? "0" + n : n;
  };

  calcPace = (set) => {
    let pace;
    let sec = this.rounder(
      (this.state.pace / 400) * set["distance"] * (1 / set["pace"]),
      0.5
    );
    if (sec > 90) {
      pace = Math.floor(sec / 60) + ":" + this.pad(sec % 60);
    } else {
      pace = sec;
    }
    return pace;
  };

  createWorkoutText = (workout) => {
    return workout.sets.map((set) => set.set + " @ " + this.calcPace(set));
  };

  createWorkoutCell = (type, workout) => {
    let workoutText;
    if (type === "Pace Work" || type === "Skill Work" || type === "Speed Work")
      workoutText = workout.sets.map(
        (set) => set.set + " @ " + this.calcPace(set)
      );
    else if (type === "Long Run")
      workoutText = [this.rounder(this.state.mileage * 0.22, 1) + " mile run"];
    else if (type === "Base Work")
      workoutText = [
        this.rounder(this.state.mileage * 0.1 * 8, 5) + " minute XT",
      ];
    const workoutCell = (
      <div>
        <div className="b">{type}</div>
        {workoutText.map((line) => (
          <div>{line}</div>
        ))}
      </div>
    );
    return workoutCell;
  };

  createWorkoutPlan = () => {
    const schedule = [];
    for (let i = 0; i < 6; i++) {
      schedule.push([]);
      schedule[i].push("Endurance Work");
      schedule[i].push(
        this.createWorkoutCell(
          "Skill Work",
          workouts["mile"]["skill"][i % workouts["mile"]["skill"].length]
        )
      );
      schedule[i].push(this.createWorkoutCell("Base Work", null));
      schedule[i].push(
        this.createWorkoutCell(
          "Speed Work",
          workouts["mile"]["speed"][i % workouts["mile"]["speed"].length]
        )
      );
      schedule[i].push(
        this.createWorkoutCell(
          "Pace Work",
          workouts["mile"]["pace"][i % workouts["mile"]["pace"].length]
        )
      );
      schedule[i].push("OFF");
      schedule[i].push(this.createWorkoutCell("Long Run", null));
    }
    schedule[schedule.length - 1][(this.state.raceday.getDay() - 1) % 7] =
      "Race Day!";
    this.setState({ schedule: schedule });
  };

  render() {
    const workoutContent = this.state.schedule.map((week, i) => {
      return (
        <tr key={i}>
          {week.map((workout, j) => (
            <td key={j}>{workout}</td>
          ))}
        </tr>
      );
    });

    return (
      <div className="WorkoutBuilder">
        <h1>DTC Workout Builder</h1>
        <h4>PR</h4>
        <label>Minutes</label>
        <input
          type="number"
          value={this.state.PR.minutes}
          onChange={(event) => this.inputChangeHandler(event, "minutes")}
        />
        <br />
        <label>Seconds</label>
        <input
          type="number"
          value={this.state.PR.seconds}
          onChange={(event) => this.inputChangeHandler(event, "seconds")}
        />
        <div>Pace: {this.state.pace}</div>
        <br />
        <label>Mileage</label>
        <input
          type="number"
          value={this.state.mileage}
          onChange={(event) => {
            this.setState({ mileage: +event.target.value });
          }}
        />
        <br />
        <br />
        <button onClick={this.createWorkoutPlan}>Create Plan</button>
        <table>
          <thead>
            <tr>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
            </tr>
          </thead>
          <tbody>{workoutContent}</tbody>
        </table>
      </div>
    );
  }
}

export default WorkoutBuilder;
